module.exports = __webpack_public_path__ + "img/INFP.4cee4ca2.png";